import { readItem, writeItem } from './localStore';

/**
 * 홈의 의견 남기기 안내 팝업이 **누구에게, 한 번만** 뜨는지를 기억한다.
 *
 * 세 화면이 같이 읽어서 `core` 에 있다: 결과 화면이 자격을 적고, 홈이 읽어 띄우고,
 * 의견 화면이 제출로 끝낸다.
 *
 * - 없음 — 아직 자격이 없다.
 * - `eligible` — 첫 진단 결과를 들여다봤다. 다음 홈 진입에 띄운다.
 * - `done` — 이미 띄웠거나 의견을 냈다. 다시 청하지 않는다.
 *
 * 영구 플래그라 `localStorage` 다. 네이티브 셸이 값을 통째로 미러하므로 짧은 문자열로 둔다.
 */
export type FeedbackPromptState = 'eligible' | 'done';

export const FEEDBACK_PROMPT_KEY = 'muzly:feedbackPrompt';

/** 모르는 값(손상·옛 형식)은 없는 것으로 읽는다. */
export const readPromptState = (): FeedbackPromptState | null => {
  const stored = readItem(FEEDBACK_PROMPT_KEY);
  return stored === 'eligible' || stored === 'done' ? stored : null;
};

export const writePromptState = (state: FeedbackPromptState): void =>
  writeItem(FEEDBACK_PROMPT_KEY, state);

/** 결과 화면에 이만큼 머물면 들여다본 것으로 친다(기획: 10초 이상). */
export const RESULT_DWELL_MS = 10_000;

/** 지표 탭을 서로 다른 이만큼 눌러도 들여다본 것으로 친다(기획: 결과 항목 2개 이상 조회). */
export const RESULT_TABS_VIEWED = 2;

/** 홈에 들어선 뒤 팝업이 뜨기까지 — 화면 전환과 겹치지 않게(기획: 0.5~1초). */
export const FEEDBACK_PROMPT_DELAY_MS = 700;

/** 자격을 세운다 — **아직 아무 표식이 없을 때만.** 끝난 사람(`done`)을 되돌리지 않는다. */
export const markPromptEligible = (): void => {
  if (readPromptState() === null) {
    writePromptState('eligible');
  }
};
